export default "__VITE_ASSET__Db3y4LQu__"